import React from 'react';
import { DialogProps } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import ClickawayDialog from './ClickawayDialog/ClickawayDialog';

interface ResponsiveDialogProps extends DialogProps {
  smallScreenBreakpoint?: 'xs' |'sm' | 'md' | 'lg' | 'xl';
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  disableClickaway?: boolean;
}

export default function ResponsiveDialog(props: ResponsiveDialogProps): JSX.Element {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(props.smallScreenBreakpoint || 'sm'));

return (
  <ClickawayDialog
    {...props}
    fullWidth
    disableClickaway={props.disableClickaway}
    maxWidth={props.maxWidth || 'lg'}
    className={props.className || 'drag-cancel'}
    fullScreen={isSmallScreen}
    >
      {props.children}
    </ClickawayDialog>
  );
}
